import { AfterViewInit, Component } from '@angular/core';
import * as feather from 'feather-icons';

@Component({
    selector: 'app-pdgoals',
    templateUrl: './pdgoals.component.html',
    styleUrls: ['./pdgoals.component.css'],
    standalone: false
})
export class PdgoalsComponent implements AfterViewInit {

  ngAfterViewInit() {
    feather.replace();
  }

}
